function ScoreMeter({ label, value }) {
  const safeValue = Math.max(0, Math.min(100, Number(value || 0)));

  return (
    <div className="score-meter">
      <div className="score-meta">
        <span>{label}</span>
        <strong>{safeValue}%</strong>
      </div>
      <div className="score-track">
        <div className="score-fill" style={{ width: `${safeValue}%` }} />
      </div>
    </div>
  );
}

export default ScoreMeter;
